import { render, staticRenderFns } from "./room-batch-edit-form.vue?vue&type=template&id=29c70dc4&scoped=true"
import script from "./room-batch-edit-form.vue?vue&type=script&lang=js"
export * from "./room-batch-edit-form.vue?vue&type=script&lang=js"
import style0 from "./room-batch-edit-form.vue?vue&type=style&index=0&id=29c70dc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c70dc4",
  null
  
)

export default component.exports